import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Authentication/Login.vue";
import Quickpay from "./views/Authentication/Quickpay.vue";
import Quickpay1 from "./views/Authentication/Quickpay1.vue";
import QuickpaymentPlans from "./views/Authentication/QuickpaymentPlans.vue";
import Quickpayment from "./views/Authentication/Quickpayment.vue";
import Register from "./views/Authentication/Register.vue";
import Otp from "./views/Authentication/Otp.vue";
import ForgotPassword from "./views/Authentication/ForgotPassword.vue";
import Dashboard from "./views/Dashboard.vue";
import TopUp from "./views/TopUps/TopUp.vue";
import Layout from "./layouts/Default.vue";
import ManagePacks from "./views/ManagePacks/index.vue";
import CustomerPlan from "./views/ManagePacks/CustomerPlan.vue";
import ContactUs from "./views/Dashboard/ContactUs.vue";
import RenewPack from "./views/Dashboard/RenewPack.vue";
import MyAccount from "./views/Authentication/MyAccount.vue";
import AddPacks from "./views/Packs/AddPacks.vue";
import ServiceRequest from "./views/Help/ServiceRequest.vue";
import Help from "./views/Help/Help.vue";
import store from "./store";
import EditProfile from "./views/MyProfile/EditProfile.vue";
import ChangePassword from "./views/MyProfile/ChangePassword.vue";
import Report from "./views/Report";
import TC from "./views/TC";
import Policy from "./views/Policy";
import FAQ from "./views/Faq";
import FAQManager from "./views/Faq/Manage";

import { fetchAdd, fetchRenew, fetchPayments } from "./services/report";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Layout,
      beforeEnter: (to, from, next) => {
        const { path } = to;
        console.log(path);
        if (path === "/register") {
          next({
            name: "Register",
          });
        }
        if (path === "/quickpay") {
          next({
            name: "Quickpay",
          });
        }
        if (path === "/quick-pay") {
          next({
            name: "Quickpay1",
          });
        }

        const cachedUser = localStorage.getItem("in:user");
        const { id, email, mobile } = store.state.auth;
        const isLoggedIn = id && email && mobile;
        if (isLoggedIn) next();
        else {
          if (cachedUser) {
            const user = JSON.parse(cachedUser);
            const cachedLogin = user.id && user.email && user.mobile;
            if (cachedLogin) {
              store.dispatch("auth/setUser", user);
              next();
            }
          } else {
            next({
              name: "Login",
            });
          }
        }
      },
      children: [
        {
          path: "/topup",
          name: "TopUp",
          component: TopUp,
        },
        {
          path: "/topup/status/:id",
          name: "ToupStatus",
          component: TopUp,
          props: {
            status: true,
          },
        },
        {
          path: "/renew",
          name: "renew",
          component: RenewPack,
        },
        {
          path: "/my-account",
          name: "Myaccount",
          component: MyAccount,
        },
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: EditProfile,
        },
        {
          path: "/change-password",
          name: "ChangePassword",
          component: ChangePassword,
        },

        {
          path: "/add-packs",
          name: "AddPacks",
          component: AddPacks,
        },
        {
          path: "/service-request",
          name: "ServiceRequest",
          component: ServiceRequest,
        },
        {
          path: "/help",
          name: "Help",
          component: Help,
        },
        {
          path: "/manage",
          name: "ManagePack",
          component: ManagePacks,
        },
        {
          path: "/manage/add",
          name: "AddPack",
          component: ManagePacks,
          props: {
            add: true,
          },
        },
        {
          path: "/contact-us",
          name: "contactus",
          component: ContactUs,
        },
        {
          path: "/report/activation",
          name: "AddReport",
          component: Report,
          props: {
            remoteService: fetchAdd,
            context: "add",
          },
        },
        {
          path: "/report/renewal",
          name: "RenewReport",
          component: Report,
          props: {
            remoteService: fetchRenew,
            context: "renew",
          },
        },
        {
          path: "/report/payments",
          component: Report,
          props: {
            remoteService: fetchPayments,
            context: "payments",
          },
        },
        {
          path: "/faqs",
          component: FAQ,
          name: "FAQ",
        },
        {
          path: "/faqs/manage",
          component: FAQManager,
          name: "FAQManager",
        },
        {
          path: "/terms-and-conditions",
          component: TC,
          name: "TC",
        },
        {
          path: "/privacy-policy",
          component: Policy,
          name: "Policy",
        },
        {
          path: "",
          component: Dashboard,
          name: "Dashboard",
        },
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/customer-plan",
      name: "CustomerPlan",
      component: CustomerPlan,
      props: {
        add: true,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/quickpay",
      name: "Quickpay",
      component: Quickpay,
    },
    {
      path: "/quick-pay",
      name: "Quickpay1",
      component: Quickpay1,
    },
    {
      path: "/quick-pay/plan-details",
      name: "QuickpaymentPlanDetails",
      component: QuickpaymentPlans,
    },
    {
      path: "/quickpayment",
      name: "Quickpayment",
      component: Quickpayment,
    },
    {
      path: "/quickpayment/status/:id",
      name: "Quickpayment",
      component: Quickpayment,
      props: {
        status: true,
      },
    },
    {
      path: "/otp",
      name: "Otp",
      component: Otp,
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
    },
  ],
});
